import React from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'
import Intro from '../components/common/Intro'
import BtnAction from '../components/form/BtnAction'

export default function Welcome({ step }) {
  const [{ title, text, config, btn }] = useStoreState(state => [
    state.steps.pages[step],
  ])

  const {
    marginBCont,
    marginTCont,
    titleColor,
    verticalPadding,
  } = config

  const [nextStep, setOpenModal] = useStoreActions(actions => [
    actions.steps.nextStep,
    actions.form.setOpenModal,
  ])

  const handleAction = () => {
    setOpenModal(true)
    nextStep()
  }

  return (
    <div className="col">
      <Intro
        title={title}
        text={text}
        marginTCont={marginTCont}
        marginBCont={marginBCont}
        titleColor={titleColor}
        verticalPadding={verticalPadding}
      />
      <BtnAction id="participate" action={handleAction} btn={btn} />
    </div>
  )
}
